import React from 'react';

const AppBlocksTutorial = () => {
  return <div>
    <ul>
      <li>
        In your Shopify admin, go to &apos;Sales channels&apos; &gt; &apos;Themes&apos; &gt; &apos;Customize&apos;<br/>
        <img src="/uploads/instructions/tutorials-app-blocks-customize.png"
             alt="Customize theme"
             className="ms-3"/>
      </li>
      <li>
        Navigate to the page where you want to display the form. Click on &apos;Add section&apos; or &apos;Add block&apos;:<br/>
        <img src="/uploads/instructions/tutorials-app-blocks-add-section.png"
             alt="Add section"
             className="ms-4"/>
      </li>
      <li>
        Scroll down to the app &apos;APPS&apos; section and click on &apos;Custom form&apos;:<br/>
        <img src="/uploads/instructions/tutorials-app-blocks-apps-section.png"
             alt="App section"
             className="ms-4"/>
      </li>
      <li>
        If you click on the form section, you will see the settings appear in a panel:<br/>
        <img src="/uploads/instructions/tutorials-app-blocks-form-settings.png"
             alt="Form section settings"
             className="ms-4"/><br/>
        You can choose which form is being displayed by entering the ID of the form.
      </li>
    </ul>
  </div>;
}

export default AppBlocksTutorial;